/**
 * @generated SignedSource<<659ab961d54a219acb083baf2058be3c>>
 * @relayHash 49ac11da82d9995047c09c3f470ca5da
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 49ac11da82d9995047c09c3f470ca5da

import { ConcreteRequest } from 'relay-runtime';
export type chatLinkIdentifiersQuery$variables = {
  chatThreadId: string;
};
export type chatLinkIdentifiersQuery$data = {
  readonly appointmentIdentifiersByChatThreadId: {
    readonly appointmentId: number;
    readonly patientId: string;
  } | null;
};
export type chatLinkIdentifiersQuery = {
  response: chatLinkIdentifiersQuery$data;
  variables: chatLinkIdentifiersQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "chatThreadId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "chatThreadId",
        "variableName": "chatThreadId"
      }
    ],
    "concreteType": "AppointmentIdentifiersOutput",
    "kind": "LinkedField",
    "name": "appointmentIdentifiersByChatThreadId",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "appointmentId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "patientId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "chatLinkIdentifiersQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "chatLinkIdentifiersQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "49ac11da82d9995047c09c3f470ca5da",
    "metadata": {},
    "name": "chatLinkIdentifiersQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "8d6f90b007d6b44bbe02b21b4284dcb9";

export default node;
